import { PublicPlacesService } from './../../core/services/public-places.service';
import { SharedModule } from './../../shared/shared.module';
import { FooterComponent } from './components/footer/footer.component';
import { HeaderComponent } from './components/header/header.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HomeRoutingModule } from './home-routing.module';
import { HomeComponent } from './pages/home/home.component';
import { IndexComponent } from './pages/index/index.component';

import { SwiperModule } from 'ngx-swiper-wrapper';
import { SWIPER_CONFIG } from 'ngx-swiper-wrapper';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';
import { UnderConstructionComponent } from './pages/under-construction/under-construction.component';
import { NgxSpinnerModule } from "ngx-spinner";
import { VillageGovernanceComponent } from './pages/village-governance/village-governance.component';
import { GovernanceSettingsResolver } from './resolvers/governance-settings.resolver';
import { AboutUsComponent } from './pages/about-us/about-us.component';
import { PublicPlacesComponent } from './pages/public-places/public-places.component';
import { PublicPlacesSettingsResolver } from './resolvers/public-places-settings.resolver';
import { AboutVillageSettingsResolver } from './resolvers/about-village-settings.resolver';
import { GovernmentOfficesSettingsComponent } from './pages/government-offices-settings/government-offices-settings.component';
import { GovernmentOfficesSettingsResolver } from './resolvers/government-offices-settings.resolver';
import { InitiativesComponent } from './pages/initiatives/initiatives.component';
import { InitiativesSettingsResolver } from './resolvers/initiatives-settings.resolver';
import { TransportationFacilitiesSettingsComponent } from './pages/transportation-facilities-settings/transportation-facilities-settings.component';
import { TransportationFacilitiesSettingsResolver } from './resolvers/transportation-facilities-settings.resolver';
import { EventsSettingsComponent } from './pages/events-settings/events-settings.component';
import { EventsSettingsResolver } from './resolvers/events-settings.resolver';
import { VillageVideoItemsComponent } from './pages/village-video-items/village-video-items.component';
import { VillageContactSettingsComponent } from './pages/village-contact-settings/village-contact-settings.component';
import { VillageContactSettingsResolver } from './resolvers/village-contact-settings.resolver';
import { VillageVirtualOfficesComponent } from './pages/village-virtual-offices/village-virtual-offices.component';
import { ProminentPlacesComponent } from './components/prominent-places/prominent-places.component';
import { ProgressiveInitiativesComponent } from './components/progressive-initiatives/progressive-initiatives.component';
import { VilllageGovernanceOfficesComponent } from './components/villlage-governance-offices/villlage-governance-offices.component';
import { VisionMissionComponent } from './components/vision-mission/vision-mission.component';
import { AboutComponent } from './pages/about/about.component';
import { HomeBannerComponent } from './pages/home-banner/home-banner.component';
import { NewsletterService } from './services/newsletter.service';

const DEFAULT_SWIPER_CONFIG: SwiperConfigInterface = {
  direction: 'horizontal',
  slidesPerView: 'auto'
};


@NgModule({
  declarations: [
    HomeComponent,
    IndexComponent,
    HeaderComponent,
    FooterComponent,
    UnderConstructionComponent,
    VillageGovernanceComponent,
    AboutUsComponent,
    PublicPlacesComponent,
    GovernmentOfficesSettingsComponent,
    InitiativesComponent,
    TransportationFacilitiesSettingsComponent,
    EventsSettingsComponent,
    VillageVideoItemsComponent,
    VillageContactSettingsComponent,
    VillageVirtualOfficesComponent,
    ProminentPlacesComponent,
    ProgressiveInitiativesComponent,
    VilllageGovernanceOfficesComponent,
    VisionMissionComponent,
    AboutComponent,
    HomeBannerComponent
  ],
  imports: [
    CommonModule,
    HomeRoutingModule,
    SharedModule,
    SwiperModule,
    NgxSpinnerModule
  ],
  providers: [
    {
      provide: SWIPER_CONFIG,
      useValue: DEFAULT_SWIPER_CONFIG
    },
    GovernanceSettingsResolver,
    PublicPlacesSettingsResolver,
    AboutVillageSettingsResolver,
    GovernmentOfficesSettingsResolver,
    InitiativesSettingsResolver,
    TransportationFacilitiesSettingsResolver,
    EventsSettingsResolver,
    VillageContactSettingsResolver,
    NewsletterService
  ],
  exports:[
    HomeBannerComponent
  ]

})

export class HomeModule { }
